import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User performed a search',
  name: 'searched',
  params: [
    {
      description: 'The search query',
      name: 'query',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
